import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-blog',
  templateUrl: './create-blog.component.html',
  styleUrls: ['./create-blog.component.scss']
})
export class CreateBlogComponent implements OnInit, AfterViewInit {
  @Input() sectionInfo: any;
  @Input() orderId: number;
  @Input() typeId: number;
  fileImg64: any;
  wrongSizeDetail: any;
  fileDetailImg: any;
  wrongSize: any;
  blogForm: FormGroup;
  fileUserImg64: any;
  wrongSizeUserImg: any;
  zuluDate: any;
  date: any;
  img64Upload = false;
  imgUser64Upload = false;
  imgDetailUpload = false;
  selectable = true;
  removable = true;
  addOnBlur = true;
  initialKeywordList = [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  blogParagraphXML = [];
  blogsDeleted: any = [];

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
    this.zuluDate = new Date().toISOString();
  }

  ngAfterViewInit(): void {
    if (this.sectionInfo.id) {
      this.updateForm();
    }
  }

  private updateForm() {
    this.blogForm.get('title').setValue(this.sectionInfo.title);
    this.blogForm.get('content').setValue(this.sectionInfo.content);
    // this.blogForm.get('contentDescription').setValue(this.sectionInfo.information.content);
    this.blogForm.get('name').setValue(this.sectionInfo.name);
    this.blogForm.get('img64').setValue(this.sectionInfo.img);
    this.blogForm.get('imgUser64').setValue(this.sectionInfo.imgUser);
    this.blogForm.get('imgDetail64').setValue(this.sectionInfo.information.img);


    // this.blogForm.get('img').setValidators(null);
    // this.blogForm.get('imgUser').setValidators(null);

    this.fileImg64 = this.sectionInfo.img;
    this.fileUserImg64 = this.sectionInfo.imgUser;
    this.fileDetailImg = this.sectionInfo.information.img;
    this.initialKeywordList = this.sectionInfo.titles;
  }


  sendData(): any {
    // if (this.blogForm.get('contentDescription').value.length > 7800) {
    //   Swal.fire({
    //     title: 'Descripción',
    //     text: 'Debe tener máximo 7800 caracteres',
    //     icon: 'warning',
    //     backdrop: false,
    //     confirmButtonText: 'Aceptar',
    //   });
    //   return;
    // }

    let dataToSend;
    this.blogForm.get('date').setValue(this.zuluDate);

    var h3s = '';
    this.sectionInfo.information.contents.forEach(item => {
      h3s = '';
      item.h3s.forEach(itemH3 => {
        h3s = itemH3.h3Description + ',' + h3s;
      });
      item.h3string = h3s.substring(0, h3s.length - 1);
    });

    if (this.sectionInfo.id) {
      dataToSend = {
        ...this.blogForm.value,
        typeId: this.sectionInfo.typeId,
        orderId: this.sectionInfo.index,
        id: this.sectionInfo.id,
        img64Upload: this.img64Upload,
        imgUser64Upload: this.imgUser64Upload,
        imgDetail64Upload: this.imgDetailUpload,
        titleDescription: this.blogForm.value.title,
        dateDescription: this.blogForm.value.date,
        titles: this.initialKeywordList,
        codeImg: 1,
        blogParagraphXML: this.sectionInfo.information.contents.concat(this.blogsDeleted)
      };
    } else {
      dataToSend = {
        ...this.blogForm.value,
        orderId: this.orderId,
        typeId: this.typeId,
        titleDescription: this.blogForm.value.title,
        dateDescription: this.blogForm.value.date,
        titles: this.initialKeywordList,
        codeImg: 1,
        blogParagraphXML: this.sectionInfo.information.contents
      };
    }

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.blogForm = this.fb.group({
      title: ['', Validators.required],
      name: ['', Validators.required],
      content: ['', Validators.required],
      // contentDescription: ['', Validators.required],
      date: [null],
      img: ['', this.sectionInfo?.id ? null : Validators.required],
      img64: ['', Validators.required],
      imgUser: ['', this.sectionInfo?.id ? null : Validators.required],
      imgUser64: ['', Validators.required],
      imgDetail: ['', this.sectionInfo?.id ? null : Validators.required],
      imgDetail64: ['', Validators.required],
    });

    if (!this.sectionInfo) {
      this.sectionInfo = {
        information: {
          contents: []
        }
      };

      this.createBlog();
    }
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 500 && image.height <= 500) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.blogForm.get('img').setValue((event.target.files[0]).name);
          this.blogForm.get('img64').setValue(this.fileImg64.split(',')[1]);
          if (this.sectionInfo.id) {
            this.img64Upload = true;
          }
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 500px x 500px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  getUserImgBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 100 && image.height <= 100) {
          this.wrongSizeUserImg = null;
          this.fileUserImg64 = image.src;
          this.blogForm.get('imgUser').setValue((event.target.files[0]).name);
          this.blogForm.get('imgUser64').setValue(this.fileUserImg64.split(',')[1]);
          if (this.sectionInfo.id) {
            this.imgUser64Upload = true;
          }
        } else {
          this.wrongSizeUserImg = 'Resolución de imagen no permitida (requerida: 100px x 100px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  getImgDetail64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 1200 && image.height <= 800) {
          this.wrongSizeDetail = null;
          this.fileDetailImg = image.src;
          this.blogForm.get('imgDetail').setValue((event.target.files[0]).name);
          this.blogForm.get('imgDetail64').setValue(this.fileDetailImg.split(',')[1]);
          if (this.sectionInfo.id) {
            this.imgDetailUpload = true;
          }
        } else {
          this.wrongSizeDetail = 'Resolución de imagen no permitida (requerida: 1200px x 800px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }


  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.initialKeywordList.push({
        orderId: this.initialKeywordList.length + 1,
        title: value
      });
    }

    // Clear the input value
    if (event.input) {
      event.input.value = '';
    }
  }

  remove(fruit: any): void {
    const index = this.initialKeywordList.indexOf(fruit);

    if (index >= 0) {
      this.initialKeywordList.splice(index, 1);
    }
  }


  validateEmptyFields(): any {
    return !(this.sectionInfo.titles.length >= 1);
  }

  addH3(event: MatChipInputEvent, i: number): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.sectionInfo.information.contents[i].h3s.push({
        id: this.sectionInfo.information.contents[i].h3s.length + 1,
        h3Description: value
      });
    }

    // Clear the input value
    if (event.input) {
      event.input.value = '';
    }
  }

  removeH3(itemH3: any, i: number): void {
    const index = this.sectionInfo.information.contents[i].h3s.indexOf(itemH3);

    if (index >= 0) {
      this.sectionInfo.information.contents[i].h3s.splice(index, 1);
    }
  }

  createBlog() {
    this.sectionInfo.information.contents.push(
      {
        id: 0,
        title: '',
        content: '',
        h3s: [],
        active: 0,
        orderId: this.sectionInfo.information.contents.length + 1
      }
    );
  }

  deleteBlog(i: number): any {
    if (this.sectionInfo.information.contents.length == 1) {
      Swal.fire({
        title: 'Oops...',
        text: 'Debes tener al menos un Párrafo',
        icon: 'error',
        backdrop: false,
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    this.sectionInfo.information.contents[i].active = 1;
    this.blogsDeleted.push(this.sectionInfo.information.contents[i]);
    this.sectionInfo.information.contents.splice(i, 1);
  }

  moveBlog(i: number, y: number) {
    if (y == 1) { // Up
      if (i == 0) { return false };
      this.sectionInfo.information.contents[i].orderId = this.sectionInfo.information.contents[i].orderId - 1;
      this.sectionInfo.information.contents[i - 1].orderId = this.sectionInfo.information.contents[i - 1].orderId + 1;
    } else if (y == 2) { // Down
      if (i == this.sectionInfo.information.contents.length - 1) { return false };
      this.sectionInfo.information.contents[i].orderId = this.sectionInfo.information.contents[i].orderId + 1;
      this.sectionInfo.information.contents[i + 1].orderId = this.sectionInfo.information.contents[i + 1].orderId - 1;
    }

    this.sectionInfo.information.contents = this.sectionInfo.information.contents.sort((a, b) => a.orderId - b.orderId);
  }

}
